import { useTranslation } from 'react-i18next';
import { BadgeProps } from '@anyui/core';
import { WarningReason } from '@anytag/graphql';

export const useGetPostWarningReasonStatusProps = () => {
  const { t } = useTranslation();

  const getPostWarningReasonStatusProps = (warningReason: WarningReason): BadgeProps => {
    switch (warningReason) {
      case WarningReason.AD_FRAUD:
        return { children: t('Option.Ad fraud'), color: 'yellow' };
      case WarningReason.API_ERROR:
        return { children: t('Option.Upload insight'), color: 'yellow' };
      case WarningReason.SCRAPING_ERROR:
        return { children: t('Option.Upload insight'), color: 'red' };
      case WarningReason.COUPON_MISSING:
        return { children: t('Option.Code missing'), color: 'red' };
      case WarningReason.DELETED_POST:
        return { children: t('Option.Deleted post'), color: 'zinc' };
      case WarningReason.INVALID_CONTENT:
        return { children: t('Option.Invalid content'), color: 'red' };
      case WarningReason.INVALID_TOKEN:
      case WarningReason.EXPIRED_TOKEN:
        return { children: t('Option.Invalid token'), color: 'red' };
      default:
        return { children: null, color: 'zinc' };
    }
  };

  return { getPostWarningReasonStatusProps };
};
